import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgPencil = function SvgPencil(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M19.96 11.5c-.53 0-.96.448-.96 1V21c0 .552-.43 1-.96 1H3.64c-.53 0-.96-.448-.96-1V4c0-.552.43-1 .96-1h9.6c.53 0 .96-.448.96-1s-.43-1-.96-1h-9.6C2.05 1 .76 2.343.76 4v17c0 1.657 1.29 3 2.88 3h14.4c1.591 0 2.88-1.343 2.88-3v-8.5c0-.552-.43-1-.96-1z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M23.239.582a1.882 1.882 0 00-2.715 0L10.648 10.87a.501.501 0 00-.106.168l-1.36 3.535a.515.515 0 00.106.539c.137.14.339.183.518.112L13.2 13.81a.491.491 0 00.162-.111l9.877-10.29a2.06 2.06 0 000-2.827z"
  }));
};

export default SvgPencil;